export default __webpack_public_path__ + "static/media/cert.a7f8cd53.svg";